import Icon from 'components/Icon';
import ImpressionEvent from 'components/ImpressionEvent';
import Listing from 'components/Listing';
import { EventContext } from 'context/EventContext';
import { getImpressionStatus } from 'helpers/eventHelpers';
import useViewport from 'hooks/useViewport';

import MoreLikeThis from './components/MoreLikeThisSection';

import classes from './ListingCard.module.scss';

/** @type {import('./types').default} */
const ListingCard = ({
  listing,
  onShowPricingModal,
  hasDemoForm = false,
  listingPosition,
  showPriceCta = false,
}) => {
  const { between } = useViewport();
  const onlySaveIcon = between('sm', 'md');

  return (
    <EventContext value={{ engagementComponent: 'product_card-item' }}>
      <ImpressionEvent
        className={classes.listingCard}
        event={{
          name: 'product_impression',
          productImpressionUuid: listing.global_product_id,
          productImpressionPosition: listingPosition,
          productImpressionStatus: getImpressionStatus(listing.is_premium),
        }}
      >
        <Listing.Card key={listing.name}>
          <Listing.Header
            listing={listing}
            component="h2"
            listingPosition={listingPosition}
            enableBuyerIntent={true}
          >
            <Listing.Buttons.Main
              listingPosition={listingPosition}
              className={classes.mainCta}
              listing={listing}
              enableBuyerIntent={true}
              onShowPricingModal={onShowPricingModal}
              hasDemoForm={hasDemoForm}
              showPriceCta={showPriceCta}
              endIcon={
                listing.is_premium && (
                  <Icon icon={['far', 'external-link']} size="16" />
                )
              }
            />
            <Listing.Buttons.CompareSave
              listing={listing}
              onlySaveIcon={onlySaveIcon}
              className={classes.compareSave}
            />
          </Listing.Header>
          <Listing.Description listing={listing} />
          <EventContext
            value={{ engagementComponent: 'product_card-item_more-like-this' }}
          >
            <MoreLikeThis
              listing={listing}
              fallbackAlternatives={listing.similar_alternatives_fallback}
            />
          </EventContext>
        </Listing.Card>
      </ImpressionEvent>
    </EventContext>
  );
};

export default ListingCard;
